<template>
  <v-dialog v-model="model" persistent width="350">
    <v-card>
      <v-card-title>Confirmación de acción especial</v-card-title>
      <v-card-text>
        <v-text-field type="password" placeholder="Contraseña de sistema" v-model="password"></v-text-field>
        <v-spacer></v-spacer>
        <div class="text-right">
          <v-btn color="error" @click="cancel">Cancelar</v-btn>
          <v-btn color="primary" @click="confirm">Confirmar</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "Confirmacion",
  props: {
    model: Boolean
  },
  data: () => ({
    password: "",
    confirmed: false
  }),
  methods: {
    confirm() {
      this.confirmed = this.password === "1234";
      if (!this.confirmed) {
        this.$awn.alert("La contraseña es incorrecta, se cancelará la acción");
      }
      this.password = null;
      this.$emit("result", this.confirmed);
    },
    cancel() {
      this.password = null;
      this.$emit("result", false);
      this.$awn.warning("Acción cancelada por el usuario");
    }
  }
});
</script>